import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, Switch, Redirect, Route, useRouteMatch } from "react-router-dom";

import { updateLoginStatus } from "../../../store/userSlice";
import { SubPageHeader } from "../../SubPageHeader";
import { About } from "./About";
import { Terms } from "./Terms";
import { Notices } from "./Notices";
import { Notice } from "./Notice";

export const Intro = () => {
  let match = useRouteMatch();
  const currentPath = window.location.pathname;
  const currentPage = currentPath.includes("/notices/")
    ? "notices"
    : currentPath.substring(
        currentPath.lastIndexOf("/") + 1,
        currentPath.length
      );

  // Update login status
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateLoginStatus());
  }, [currentPage, dispatch]);

  return (
    <div>
      <SubPageHeader
        categoryUrl={match.path}
        categoryName="intro"
        pageName={currentPage}
      />
      <Switch>
        <Route exact path={`${match.path}`}>
          <Redirect to={`${match.path}/about`} />
        </Route>
        <Route path={`${match.path}/about`}>
          <About />
        </Route>
        <Route path={`${match.path}/terms`}>
          <Terms />
        </Route>
        <Route exact path={`${match.path}/notices`}>
          <Notices />
        </Route>
        <Route path={`${match.path}/notices/:id`}>
          <Notice />
        </Route>
        <Route>
          <div className="container">
            <div className="sub-container">
              <h3>페이지를 찾을 수 없습니다.</h3>
              <span>
                <Link to="/">홈 화면으로 가기</Link>
              </span>
            </div>
          </div>
        </Route>
      </Switch>
    </div>
  );
};
